import { render } from "./register.vue?vue&type=template&id=57055810&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=57055810&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57055810"]])

export default __exports__